import { render, staticRenderFns } from "./AdWrite.vue?vue&type=template&id=f2bb470a&"
import script from "./AdWrite.vue?vue&type=script&lang=js&"
export * from "./AdWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports